export const SUNLOCK_STATUS_READY = 'Ready';
export const SUNLOCK_STATUS_ACTIVE = 'Active';
export const SUNLOCK_STATUS_INACTIVE = 'Inactive';
export const SUNLOCK_STATUS_UNREACHABLE = 'Unreachable';
export const SUNLOCK_STATUS_DELETED = 'Deleted';

export const SUNLOCK_STATUS_LIST = [
  SUNLOCK_STATUS_READY,
  SUNLOCK_STATUS_ACTIVE,
  SUNLOCK_STATUS_INACTIVE,
  SUNLOCK_STATUS_UNREACHABLE,
  SUNLOCK_STATUS_DELETED,
];

export const SUNLOCK_STATUS_AVAILABLE_TRANSITIONS = {
  [SUNLOCK_STATUS_READY]: [
    SUNLOCK_STATUS_ACTIVE,
    SUNLOCK_STATUS_INACTIVE,
    SUNLOCK_STATUS_DELETED,
  ],
  [SUNLOCK_STATUS_ACTIVE]: [
    SUNLOCK_STATUS_INACTIVE,
    SUNLOCK_STATUS_UNREACHABLE,
    SUNLOCK_STATUS_DELETED,
  ],
  [SUNLOCK_STATUS_INACTIVE]: [
    SUNLOCK_STATUS_READY,
    SUNLOCK_STATUS_DELETED,
  ],
  [SUNLOCK_STATUS_UNREACHABLE]: [
    SUNLOCK_STATUS_ACTIVE,
    SUNLOCK_STATUS_INACTIVE,
    SUNLOCK_STATUS_DELETED,
  ],
  [SUNLOCK_STATUS_DELETED]: [
    SUNLOCK_STATUS_INACTIVE,
  ],
};

// WARNING(@d-oliveros): Do not update! The Sunlocks server expect these values.
export const SUNLOCK_COMMAND_LOCK_DOOR = 'lock';
export const SUNLOCK_COMMAND_UNLOCK_DOOR = 'unlock';

export const SUNLOCK_COMMAND_LIST = [
  SUNLOCK_COMMAND_LOCK_DOOR,
  SUNLOCK_COMMAND_UNLOCK_DOOR,
];

export const SUNLOCK_ALERT_READY_STATUS_DAYS_TRESHOLD = 3;
export const SUNLOCK_ALERT_BATTERY_LEVEL_TRESHOLD = 50;

export const SUNLOCK_DOOR_WINDOW_SENSOR_STATUS_OPEN = 'open';
export const SUNLOCK_DOOR_WINDOW_SENSOR_STATUS_CLOSE = 'close';
export const SUNLOCK_DOOR_WINDOW_TAMPER_STATUS_MOUNTED = 'mounted';
export const SUNLOCK_DOOR_WINDOW_TAMPER_STATUS_UNMOUNTED = 'unmounted';
